import { useMediaQuery,Grid2,Typography,Paper,InputBase,Divider,Box,Button,List,ListItem,ListItemText } from "@mui/material"
import Styles from "./Styles.module.css"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState, useEffect, useRef, useCallback } from "react";
import PostList from "./PostList";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { backendHosts,apiUrl } from "../../../../ui-utils/apiConfig";

function slugify(title) {
    return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
}
export default function ResearchPosts() {

    const [allTags, setAllTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState(null);
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const observer = useRef();
    const loadingRef = useRef(false);
    const sentinelRef = useRef(null);
    const containerRef = useRef(null);
    const isSmallDevice = useMediaQuery("(max-width: 767px)");


    const navigate = useNavigate()

    // const { language } = useLanguage();

    // console.log("language",language)
    // const translations = { en, hi, kn };
    // const t = translations[language] || translations.en;

    const fetchBlogs = useCallback(
        async (pageNum, tag = null) => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            const limit = isSmallDevice ? 3 : 6;
            try {
                let endPoint
                if(tag){
                    endPoint = `/api/research/all?category_id=${tag}&page=${pageNum}&limit=${limit}`;
                }else{
                    endPoint = `/api/research/all?page=${pageNum}&limit=${limit}`;
                }
                // const response = await httpRequest({
                //     endPoint,
                //     method: "get",
                //     instance: "instanceOne",
                // });
                const response = await axios.get(`${backendHosts.ADMIN}${endPoint}`)

                if (response?.data?.data?.data && response?.data?.data.pagination) {
                    setBlogs((prev) => {
                        // If it's the first page or tag changed, replace the blogs
                        if (pageNum === 1 || tag !== selectedTag) {
                            return response.data.data.data;
                        }
                        // Otherwise, append new blogs
                        return [...prev, ...response.data.data.data];
                    });
                    setTotalPages(response.data?.data.pagination.totalPages);
                    setHasMore(pageNum < response.data.data?.pagination.totalPages);
                }
            } catch (error) {
                console.error("Error fetching blogs", error);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        },
        [selectedTag]
    );

    const [loadingTags, setLoadingTags] = useState(false);


    const fetchTags = useCallback(async () => {
        setLoadingTags(true);
        try {

            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getCategories}`)
            console.log("responsee",response)
            // const response = await httpRequest({
            //     endPoint: `api/blogs/tags`,
            //     method: "get",
            //     instance: "instanceOne",
            // });
            setAllTags(response.data?.data?.data || []);
        } catch (error) {
            console.error("Error fetching tags", error);
        } finally {
            setLoadingTags(false);
        }
    }, []);

    useEffect(() => {
        fetchTags();
    }, [fetchTags]);

    useEffect(() => {
        setBlogs([]);
        setPage(1);
        setHasMore(true);
    }, [selectedTag]);

    useEffect(() => {
        fetchBlogs(page, selectedTag);
    }, [page, selectedTag, fetchBlogs]);

    useEffect(() => {
        if (!hasMore || loading) return;

        const options = {
            root: null,
            rootMargin: "200px",
            threshold: 0.1,
        };

        const handleIntersection = (entries) => {
            const [entry] = entries;
            if (entry.isIntersecting && !loadingRef.current) {
                setPage((prev) => {
                    if (prev < totalPages) {
                        return prev + 1;
                    }
                    return prev;
                });
            }
        };

        observer.current = new IntersectionObserver(handleIntersection, options);

        if (sentinelRef.current) {
            observer.current.observe(sentinelRef.current);
        }

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [hasMore, loading, totalPages]);

    const handleTagClick = useCallback((id) => {
        console.log("tabclick",id)
        setSelectedTag((prevTag) => {
            const newTag = prevTag === id ? null : id;
            setPage(1);
            return newTag;
        });
    }, []);

    const handleCardClick = (blog) => {
        const slug = slugify(blog.blog_title);
        navigate(`/learn-research/blogs/${blog.id}-${slug}`);
        window.scrollTo(0, 0);
    };

    return (
        <div ref={containerRef} className={Styles.maincard}>
        <Grid2
            item
            xs={12}
            textAlign="center"

        >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "550px", // adjust based on how much DFFFE2 you want
                        zIndex: 1,
                    }}
                />
                <Grid2
                    item
                    xs={12}
                    textAlign="center"
                    sx={{
                        position: "relative",
                        zIndex: 2, // content is above both backgrounds
                        pt: 10,
                    }}
                >

                    <Grid2
                        item
                        xs={12}
                        sx={{
                            maxWidth: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            my: 5,
                        }}
                    >
                        <Box
                            sx={{
                                width: "fit-content",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: { xs: 1, sm: 2, md: 3 },
                                px: { xs: 2, sm: 4, md: 6 },
                                mx: 2,
                                py: { xs: 1, sm: 2 },
                                justifyContent: "center",
                                position: "relative",
                                borderRadius: "20px",
                                color: "#fff",
                                fontFamily: "Inter400",
                                fontSize: { xs: "calc(14px + var(--font-delta))", sm: "calc(16px + var(--font-delta))", md: "calc(18px + var(--font-delta))", lg: "calc(20px + var(--font-delta))" },
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    inset: 0,
                                    padding: "2px",
                                    borderRadius: "inherit",
                                    background:
                                        "linear-gradient(120deg, #FBFF05 0%, #137DF7 25%,rgb(229, 74, 74) 75%, #16F1DF 100%)",
                                    WebkitMask:
                                        "linear-gradient(white, white) content-box, linear-gradient(white, white)",
                                    WebkitMaskComposite: "xor",
                                    maskComposite: "exclude",
                                    pointerEvents: "none",
                                    filter: "blur(12px)",
                                    zIndex: 1,
                                },
                                boxShadow:
                                    "0px 0px 10px rgba(251, 255, 5, 0.6), " +
                                    "0px 0px 20px rgba(19, 125, 247, 0.5), " +
                                    "0px 0px 30px rgba(238, 16, 16, 0.4), " +
                                    "0px 0px 40px rgba(22, 241, 223, 0.3), " +
                                    "inset 0px 0px 10px rgba(251, 255, 5, 0.6), " +
                                    "inset 0px 0px 20px rgba(19, 125, 247, 0.5), " +
                                    "inset 0px 0px 30px rgba(238, 16, 16, 0.4), " +
                                    "inset 0px 0px 40px rgba(22, 241, 223, 0.3)",
                            }}
                        >

                            <Box
                                sx={{
                                    width: "fit-content",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    px: 2,
                                    py: 1,
                                    borderBottom:
                                        selectedTag === null
                                            ? "2px solid #F3D45E"
                                            : "2px solid transparent",
                                    color: selectedTag === null ? "#F3D45E" : "#fff",
                                    transition: "border-color 0.3s, color 0.3s",
                                    "&:hover": {
                                        borderBottom: "2px solid #F3D45E",
                                        color: "#F3D45E",
                                    },
                                }}
                                onClick={() => handleTagClick(null)}
                            >
                                All
                            </Box>

                            {allTags.map(({ id,category_name }) => (
                                <Box
                                    key={id}
                                    sx={{
                                        width: "fit-content",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        px: 2,
                                        py: 1,
                                        borderBottom:
                                            selectedTag === id
                                                ? "2px solid #F3D45E"
                                                : "2px solid trasparant",
                                        color: selectedTag === id ? "#F3D45E" : "#fff",
                                        transition: "border-color 0.3s, color 0.3s",
                                        "&:hover": {
                                            borderBottom: "2px solid #F3D45E",
                                            color: "#F3D45E",
                                        },
                                    }}
                                    onClick={() => handleTagClick(id)}
                                >
                                    {category_name}
                                </Box>
                            ))}
                        </Box>
                    </Grid2>



                <PostList blogs={blogs} />

                    <div
                        ref={sentinelRef}
                        style={{
                            height: "1px",
                            width: "100%",
                        }}
                    />

       </Grid2>

        </Grid2>
    </div>
    )
}